var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.838867,
    y: 29.1611,
    width: 41.2402,
    height: 41.2402,
    rx: 20.6201,
    transform: "rotate(-45 0.838867 29.1611)",
    fill: "url(#paint0_linear_1071_2101)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2839 20.8945L30.1196 29.1426L37.9552 20.8945",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2839 33.2676L30.1196 41.5156L37.9552 33.2676",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1071_2101",
    x1: 21.7455,
    y1: 29.8938,
    x2: 21.1657,
    y2: 70.3972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#487B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#79AAC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D1E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeta);
export default __webpack_public_path__ + "static/media/icon-seta.fd3ff6bf197af7db8281f25d3246ac69.svg";
export { ForwardRef as ReactComponent };